module.exports = __webpack_public_path__ + "../static/img/base_ap.cb80ce86.png";